/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, takeLatest, put } from "redux-saga/effects";
import { newRequest } from "../../../api/token";
import {
  ADD_CONTACT_US_INFO_LIST,
  ADD_NEWSLETTER_MAILING_LIST,
  MUTATION_AGENT_SIGNUP,
} from "../../actionTypes/homeActionTypes";
import {
  addNewsLetterMailingListAction,
  addContactUsInfoAction,
  mutationAgentSignUpAction,
} from "../../actions/homeActions";
import { setZohoTicketCreationAction } from "../../actions/dashboardActions";
import { AGENT_SIGNUP } from "../../gqlQueries/authQuery";
import { ZOHO_CREATE_TICKET } from "../../gqlQueries/Dashboard/searchPageQuery";
import { ADD_CONTACT_US_INFO_QUERY, ADD_NEWSLETTER_MAILING_LIST_QUERY } from "../../gqlQueries/homeQuery";
import { getNotificationMessage } from "../../actions/localStorageActions";
import { isGlobalApolloError } from "../../../utils/helpers/auth";
//import { customNotify } from "../../../components/UI/ToastNotify";

function* mutationAgentSignUp(action: any): any {
  try {
    const graphqlMutateData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: AGENT_SIGNUP,
      data: action?.payload,
      clientType: "MO",
    });
    yield put(mutationAgentSignUpAction.FULLFILLED(graphqlMutateData));
    if (
      graphqlMutateData?.data?.agentRegistration?.successTypeCode.toLowerCase() ==
      "success"
    ) {
      action.logincallback();
    }
    if (
      graphqlMutateData?.data?.agentRegistration?.successTypeCode.toLowerCase() ==
      "failed"
    ) {

      const message = {
        isOpen: true,
        mainHeader: "Unable to Submit Form",
        subHeader: "",
        message: graphqlMutateData?.data?.agentRegistration?.messageDescription == "Record already exists" ? "Agent already exists with this email ID or details. Please Contact Admin." : graphqlMutateData?.data?.agentRegistration?.messageDescription,
        subReq: false,
      };
      yield put(getNotificationMessage(message));
    }
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    // const msg = get(error, "data.error.error", "Failed to get data");
    yield put(mutationAgentSignUpAction.REJECTED());
  }
}

function* addNewsLetterMailingList(action: any): any {
  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_NEWSLETTER_MAILING_LIST_QUERY,
      clientType: "BE",
      data: {
        email: action?.payload?.myPayload?.email,
        subscribe_status: action?.payload?.myPayload?.subscribe_status,
      },
    });
    if (
      apiData?.data?.addNewsLetterMailingList?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (apiData?.data?.addNewsLetterMailingList?.responseData) {

        yield put(
          addNewsLetterMailingListAction.FULLFILLED(
            apiData?.data?.addNewsLetterMailingList?.responseData
          )
        );
      }
    } else {
      const message = {
        isOpen: true,
        mainHeader: apiData?.data?.addNewsLetterMailingList?.messageDescription,
        subHeader: "",
        message: "",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(addNewsLetterMailingListAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Something went wrong",
      subHeader: "",
      message: "Failed to Add Newsletter Mail",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(addNewsLetterMailingListAction.REJECTED());

  }
}


function* addContactUsInfoList(action: any): any {
  const payload = {
    email: action?.payload?.payload?.email,
    subject: action?.payload?.payload?.subject,
    name: action?.payload?.payload?.cf?.cf_name,
    mobile_number: action?.payload?.payload?.cf?.cf_mobile_number,
    organization: action?.payload?.payload?.cf?.cf_organization,
    remarks: action?.payload?.payload?.cf?.cf_remarks,
    acknowledgement: action?.payload?.payload?.acknowledgement,
  }
  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: ADD_CONTACT_US_INFO_QUERY,
      clientType: "BE",
      data: {
        request: payload,
      },
    });
    if (
      apiData?.data?.addContactUsInfo?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      if (apiData?.data?.addContactUsInfo?.responseData) {
        const mutationResp = yield call(newRequest, {
          callType: "apollo",
          callMethod: "mutation",
          dataQuery: ZOHO_CREATE_TICKET,
          data: {
            input: JSON.stringify({
              email: action?.payload?.payload?.email,
              subject: action?.payload?.payload?.subject,
              priority: action?.payload?.payload?.priority,
              status: action?.payload?.payload?.status,
              cf: action?.payload?.payload?.cf,
              description: action?.payload?.payload?.description,
            }),
            document: "",
            filename: "",
          },
          clientType: "MO",
        });

        if (mutationResp?.data?.createTicket?.successTypeCode?.toLowerCase() == "success") {
          if (action?.payload?.setLoading) {
            action?.payload?.setLoading(false)
          }
          yield put(
            addContactUsInfoAction.FULLFILLED(
              apiData?.data?.addContactUsInfo?.responseData
            )
          );
          yield put(setZohoTicketCreationAction.FULLFILLED(mutationResp?.data?.createTicket?.responseData));
          if (action?.payload?.setOpenModal) {
            action?.payload?.setOpenModal(true);
          }
        } else {
          const message = {
            isOpen: true,
            mainHeader: "Failed to create Ticket",
            subHeader: "",
            message: mutationResp?.data?.createTicket?.messageDescription,
            subReq: false,
          };
          yield put(getNotificationMessage(message));
          yield put(setZohoTicketCreationAction.REJECTED());
        }
      }
    } else {
      const message = {
        isOpen: true,
        mainHeader: apiData?.data?.addContactUsInfo?.messageDescription,
        subHeader: "",
        message: "",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(addNewsLetterMailingListAction.REJECTED());
    }
  } catch (error: any) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Something went wrong",
      subHeader: "",
      message: "Failed to Add Contact Us Info",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(addNewsLetterMailingListAction.REJECTED());
    yield put(setZohoTicketCreationAction.REJECTED());
  }
}

export function* watcherHome() {
  yield takeLatest(MUTATION_AGENT_SIGNUP.STARTED, mutationAgentSignUp);
  yield takeLatest(
    ADD_NEWSLETTER_MAILING_LIST.STARTED,
    addNewsLetterMailingList
  );
  yield takeLatest(
    ADD_CONTACT_US_INFO_LIST.STARTED,
    addContactUsInfoList
  );
}

export const sagas = [watcherHome];
